import controller from '../field.controller';
import template from './phoneField.html';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    field: '<',
    onUpdate: '&',
  }
};

export default component;
